import { ReactElement, useState } from 'react';
import { Datagrid, FunctionField, List, TextField, useTranslate } from 'react-admin';
import { CustomBreadcrumbs } from 'src/components/custom-breadcrumbs';
import { DashboardContent } from 'src/layouts/dashboard';
import { PermissionButton, PermissionGuard } from 'src/routes/components';
import { Resources } from '../../resource';
import { Box, Card, Dialog, Stack, Button as MUIButton } from '@mui/material';
import Withdraw from './SignTransaction';
import { ICONS } from 'src/layouts/configs/icons';
import ErrorPage403 from 'src/pages/error/403';

const View = () => {
  const [popup, setPopup] = useState<ReactElement>();
  const translate = useTranslate();

  return (
    <PermissionGuard resource="signTransactions" action="read" fallback={<ErrorPage403 />}>
      <DashboardContent>
        <CustomBreadcrumbs heading={translate('resource.transactionSigning')} />
        <Card sx={{ mt: 3, pb: 2, paddingTop: 2 }}>
          <List exporter={false} actions={false} empty={false} pagination={false}>
            <Box sx={{ overflow: 'auto' }}>
              <Datagrid
                rowClick={false}
                bulkActionButtons={false}
                sx={{
                  '& .RaDatagrid-row': {
                    borderBottom: '12px solid important',
                  },
                }}
              >
                <TextField
                  source="address"
                  label={translate('module.withdrawal.address')}
                  sortable={false}
                />
                <TextField
                  source="chain"
                  label={translate('module.withdrawal.network')}
                  sortable={false}
                />
                <TextField
                  source="nativeBalance"
                  label={translate('module.withdrawal.nativeBalance')}
                  sortable={false}
                />
                <TextField
                  source="usdcBalance"
                  label={translate('module.withdrawal.usdcBalance')}
                  sortable={false}
                />
                <FunctionField
                  textAlign="left"
                  render={(record: any) => (
                    <Stack direction="row" spacing={4} sx={{ justifyContent: 'flex-end' }}>
                      {record.chain === 'SOLANA' ? (
                      <PermissionGuard
                        resource="finance-transfer"
                        action="request"
                        fallback={<></>}
                      >
                        <MUIButton
                          variant="outlined"
                          size="small"
                          color="primary"
                          startIcon={ICONS.pen}
                          onClick={(e) => {
                            e.preventDefault();
                            setPopup(
                              <Withdraw
                                chain={record.chain}
                                address={record.address}
                                nativeBalance={record.nativeBalance}
                                usdcBalance={record.usdcBalance}
                                onClose={() => setPopup(undefined)}
                              />
                            );
                          }}
                        >
                          {translate('resource.requestTransfer', { _: 'Request transfer' })}
                        </MUIButton>
                      </PermissionGuard>
                      ) : null}
                    </Stack>
                  )}
                />
              </Datagrid>
            </Box>
          </List>
        </Card>
        <Dialog open={Boolean(popup)} onClose={() => setPopup(undefined)} maxWidth="sm" fullWidth>
          {popup}
        </Dialog>
      </DashboardContent>
    </PermissionGuard>
  );
};

export default View;
